import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/api";

// Renders title, meta, canonical, Open Graph + JSON-LD structured data.
export default function Seo({ title, description, path = "/", image, noindex = false, jsonLd }) {
  const url = `${SITE_URL}${path}`;
  const rawImg = image || "https://aquilaairandheating.com/og-image.jpg";
  const ogImage = rawImg.startsWith("/") ? `${SITE_URL}${rawImg}` : rawImg;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  const prune = (o) => {
    if (Array.isArray(o)) return o.map(prune).filter((v) => !(v === undefined || v === null || v === "" || (Array.isArray(v) && !v.length)));
    if (o && typeof o === "object") {
      const out = {};
      Object.entries(o).forEach(([k, v]) => {
        const p = prune(v);
        const empty = p === undefined || p === null || p === "" || (Array.isArray(p) && !p.length) || (typeof p === "object" && !Array.isArray(p) && !Object.keys(p).length);
        if (!empty) out[k] = p;
      });
      return out;
    }
    return o;
  };

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(prune(b))}</script>
      ))}
    </Helmet>
  );
}
